export const translations = {
  fr: {
    nav: {
      brand: "L'Atelier Subversif",
      tagline: "Céramique subversive & illusions optiques",
      cart: "Panier",
      admin: "Admin",
      switchLang: "Sprache wechseln (DE)",
      currency: "Devise",
    },
    hero: {
      badge: "Design exclusif • Illusion anamorphique",
      subtitle: "Un motif géométrique scandinave d'une élégance absolue. Jusqu'au moment où vous l'inclinez.",
      ctaAddToCart: "Ajouter au panier",
      ctaSoldOut: "Rupture de stock temporaire",
      inStock: "En stock",
      outOfStock: "Épuisé",
      quantity: "Quantité",
      standardVariant: "Format Standard 330 ml",
      tiltHint: "Inclinez la tasse pour découvrir le message caché",
      straightView: "Vue normale (motif discret)",
      tiltedView: "Vue inclinée (message révélé)",
      rotate3D: "Tourner / Incliner",
      specsTitle: "Caractéristiques techniques",
      specMaterial: "Matériau : Céramique blanche de qualité supérieure, émaillage brillant",
      specCapacity: "Contenance : 330 ml (11 oz) standard",
      specInterior: "Détail : Intérieur et anse couleur rose vif contrasté",
      specCare: "Entretien : Compatible lave-vaisselle et micro-ondes",
      specPrint: "Impression : Motif anamorphique haute définition résistant à l'usure",
      shippingTitle: "Livraison & Expédition",
      promoApplied: "Offre spéciale active",
      save: "Économisez",
    },
    cart: {
      title: "Votre Panier",
      empty: "Votre panier est actuellement vide.",
      continueShopping: "Continuer mes achats",
      subtotal: "Sous-total",
      discount: "Remise promotionnelle",
      shipping: "Frais de livraison",
      freeShipping: "Livraison offerte",
      total: "Total à payer",
      checkout: "Procéder au paiement sécurisé",
      checkoutDisabled: "Les commandes sont temporairement désactivées",
      secureNotice: "Paiement 100% sécurisé via Stripe • Chiffrement SSL 256 bits",
      remove: "Supprimer",
    },
    order: {
      confirmationTitle: "Merci pour votre commande !",
      confirmedBadge: "Paiement validé",
      pendingBadge: "Paiement en cours de validation",
      reference: "Numéro de commande",
      date: "Date",
      currency: "Devise",
      itemsOrdered: "Articles commandés",
      emailStatusSent: "E-mail de confirmation envoyé. Pensez à vérifier vos courriers indésirables.",
      emailStatusPending: "Votre paiement a été reçu. Votre e-mail de confirmation est en cours de préparation et vous sera envoyé sous peu.",
      deliveryNotice: "Votre colis sera préparé avec soin dans un emballage neutre et protecteur.",
      backToHome: "Retourner à la boutique",
      notFound: "Commande introuvable ou lien expiré.",
      loadingOrder: "Chargement des détails de votre commande...",
    },
    faq: {
      title: "Questions Fréquentes",
      q1: "Comment fonctionne l'illusion optique ?",
      a1: "Le motif imprimé sur la tasse utilise une technique d'anamorphose géométrique. Vue de face ou verticalement, les lignes ressemblent à un élégant motif nordique traditionnel. Lorsque vous inclinez la tasse ou que vous la regardez sous un angle plongeant, la perspective aligne les tracés noirs pour révéler instantanément la phrase « FUCK THIS SHIT ».",
      q2: "La tasse passe-t-elle au lave-vaisselle et au micro-ondes ?",
      a2: "Oui. Fabriquée en céramique émaillée de haute qualité avec une impression par sublimation thermique cuite à haute température, la tasse résiste parfaitement au lave-vaisselle quotidien et aux passages répétés au micro-ondes sans altération du motif ni de la couleur rose.",
      q3: "L'emballage d'expédition est-il discret ?",
      a3: "Absolument. Nous expédions toutes les commandes dans des cartons d'expédition robustes et neutres, sans aucune mention du message secret sur le colis extérieur. Idéal si vous souhaitez faire une surprise ou l'offrir en cadeau.",
      q4: "Quels sont les délais et zones de livraison ?",
      a4: "Nous livrons en Suisse (2 à 4 jours ouvrables via La Poste) et dans toute l'Union Européenne (4 à 8 jours ouvrables). Chaque colis est expédié avec un numéro de suivi.",
    },
    footer: {
      legalNotice: "Mentions Légales",
      terms: "Conditions Générales de Vente",
      privacy: "Politique de Confidentialité",
      cookies: "Gestion des Cookies",
      shippingPolicy: "Livraison & Retours",
      withdrawal: "Droit de Rétractation",
      rights: "Tous droits réservés.",
      discreetMug: "La tasse discrète pour exprimer tout haut ce que l'on pense tout bas.",
    }
  },
  de: {
    nav: {
      brand: "L'Atelier Subversif",
      tagline: "Subversive Keramik & optische Täuschungen",
      cart: "Warenkorb",
      admin: "Admin",
      switchLang: "Changer de langue (FR)",
      currency: "Währung",
    },
    hero: {
      badge: "Exklusives Design • Anamorphische Illusion",
      subtitle: "Ein nordisches geometrisches Muster von zeitloser Eleganz. Bis zu dem Moment, in dem man die Tasse neigt.",
      ctaAddToCart: "In den Warenkorb",
      ctaSoldOut: "Vorübergehend ausverkauft",
      inStock: "Auf Lager",
      outOfStock: "Ausverkauft",
      quantity: "Menge",
      standardVariant: "Standardformat 330 ml",
      tiltHint: "Neigen Sie die Tasse, um die verborgene Nachricht zu entdecken",
      straightView: "Normale Ansicht (dezentes Muster)",
      tiltedView: "Geneigte Ansicht (enthüllte Botschaft)",
      rotate3D: "Drehen / Neigen",
      specsTitle: "Technische Eigenschaften",
      specMaterial: "Material: Hochwertige weiße Keramik mit Glanzglasur",
      specCapacity: "Fassungsvermögen: 330 ml (11 oz) Standard",
      specInterior: "Detail: Kontrastierende rosa Innenseite und rosa Henkel",
      specCare: "Pflege: Spülmaschinen- und mikrowellengeeignet",
      specPrint: "Druck: Hochauflösender, abriebfester Sublimationsdruck",
      shippingTitle: "Versand & Lieferung",
      promoApplied: "Aktive Sonderaktion",
      save: "Sie sparen",
    },
    cart: {
      title: "Ihr Warenkorb",
      empty: "Ihr Warenkorb ist derzeit leer.",
      continueShopping: "Weiter einkaufen",
      subtotal: "Zwischensumme",
      discount: "Aktionsrabatt",
      shipping: "Versandkosten",
      freeShipping: "Kostenloser Versand",
      total: "Gesamtbetrag",
      checkout: "Sicher zur Kasse",
      checkoutDisabled: "Bestellungen sind vorübergehend deaktiviert",
      secureNotice: "100% sichere Zahlung über Stripe • 256-Bit SSL-Verschlüsselung",
      remove: "Entfernen",
    },
    order: {
      confirmationTitle: "Vielen Dank für Ihre Bestellung!",
      confirmedBadge: "Zahlung bestätigt",
      pendingBadge: "Zahlung wird bestätigt",
      reference: "Bestellnummer",
      date: "Datum",
      currency: "Währung",
      itemsOrdered: "Bestellte Artikel",
      emailStatusSent: "Bestätigungs-E-Mail gesendet. Bitte prüfen Sie auch Ihren Spam-Ordner.",
      emailStatusPending: "Ihre Zahlung ist eingegangen. Ihre Bestätigungs-E-Mail wird derzeit vorbereitet und in Kürze versandt.",
      deliveryNotice: "Ihr Paket wird sorgfältig in einer neutralen, geschützten Verpackung vorbereitet.",
      backToHome: "Zurück zum Shop",
      notFound: "Bestellung nicht gefunden oder Link abgelaufen.",
      loadingOrder: "Bestelldetails werden geladen...",
    },
    faq: {
      title: "Häufig gestellte Fragen",
      q1: "Wie funktioniert die optische Täuschung?",
      a1: "Das aufgedruckte Muster nutzt das Prinzip der geometrischen Anamorphose. Von vorne betrachtet wirken die Linien wie traditionelle nordische Ornamente. Erst wenn Sie die Tasse um 90° neigen oder in einem flachen Winkel betrachten, fügen sich die schwarzen Konturen zum Schriftzug „FUCK THIS SHIT“ zusammen.",
      q2: "Ist die Tasse spülmaschinen- und mikrowellengeeignet?",
      a2: "Ja. Gefertigt aus robuster Qualitätskeramik mit hochfester Einbrennfärbung widersteht die Tasse dem täglichen Spülgang in der Spülmaschine sowie Erwärmungen in der Mikrowelle ohne Farb- oder Motivverlust.",
      q3: "Erfolgt der Versand in einem diskreten Paket?",
      a3: "Selbstverständlich. Wir versenden alle Bestellungen in stabilen, neutralen Kartons ohne Aufdruck der Botschaft auf der Außenseite. Perfekt für Überraschungen oder Geschenke.",
      q4: "Wie lauten Lieferzeiten und Versandregionen?",
      a4: "Wir liefern in die Schweiz (2 bis 4 Werktage mit der Schweizerischen Post) und in alle EU-Länder (4 bis 8 Werktage). Zu jeder Sendung erhalten Sie eine Sendungsverfolgungsnummer.",
    },
    footer: {
      legalNotice: "Impressum",
      terms: "Allgemeine Geschäftsbedingungen",
      privacy: "Datenschutzerklärung",
      cookies: "Cookie-Einstellungen",
      shippingPolicy: "Versand & Rückgabe",
      withdrawal: "Widerrufsrecht",
      rights: "Alle Rechte vorbehalten.",
      discreetMug: "Die dezente Kaffeetasse, um unaufdringlich auszusprechen, was man denkt.",
    }
  }
};
